import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/not-found.scss';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className="not-found-page">
            <div className="not-found-content">
                <div className="error-code">
                    <span className="digit">4</span>
                    <div className="zero-container">
                        <div className="zero"></div>
                    </div>
                    <span className="digit">4</span>
                </div>
                <h1>Page Not Found</h1>
                <p>The page you're looking for doesn't exist or has been moved.</p>
                <div className="action-buttons">
                    <button 
                        className="btn btn-primary" 
                        onClick={() => navigate(-1)}
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                        Go Back
                    </button>
                </div>
                <div className="error-details">
                    <p>If you believe this is a mistake, please contact support.</p>
                    <div className="error-code-text">
                        Error Code: 404
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotFoundPage; 